// Sign-in / guest-upgrade screen. For guests (anonymous session) this is the
// "keep your work" upgrade: linkWithPopup converts the anonymous account IN
// PLACE — the uid never changes, so every property/note/share created as a
// guest carries over automatically. For fully signed-out visitors it's the
// normal Google sign-in.
//
// Returns to the homepage (the map) unless the caller passed ?next=…, so a
// flow that needed a session (e.g. tracking a searched location) can send the
// user back where they were — see docs/plans/map-first-ux.md.
import {
  auth,
  signInWithPopup,
  linkWithPopup,
  GoogleAuthProvider,
} from '../lib/firebase.js';

export function renderLogin(el, { navigate, query = {} }) {
  const isGuest = !!auth.currentUser?.isAnonymous;
  // Guard against a next= that isn't a hash route (only '#/…' is navigable).
  const next = /^[\w-]+(\/[\w-]+)*(\?.*)?$/.test(query.next || '') ? `#/${query.next}` : '#/map';
  el.innerHTML = `
    <div class="auth-card">
      <h1>🏡 Property Source</h1>
      <p class="muted">${isGuest
        ? "You're exploring as a guest — your list stays on this device until you sign in. Sign in with Google to keep it forever and unlock extraction."
        : 'Track properties, share them, and run full due-diligence extraction.'}</p>
      <button class="btn" id="sign-in-btn" style="margin-top:16px">${isGuest ? 'Sign in with Google to keep your work' : 'Sign in with Google'}</button>
      <p class="error" id="sign-in-error" hidden></p>
    </div>`;
  const btn = el.querySelector('#sign-in-btn');
  const err = el.querySelector('#sign-in-error');
  btn.addEventListener('click', async () => {
    btn.disabled = true;
    err.hidden = true;
    try {
      if (auth.currentUser?.isAnonymous) {
        await linkWithPopup(auth, new GoogleAuthProvider());
      } else {
        await signInWithPopup(auth, new GoogleAuthProvider());
      }
      navigate(next); // auth listener also re-renders
    } catch (e) {
      if (e.code === 'auth/popup-closed-by-user' || e.code === 'auth/cancelled-popup-request') return;
      if (e.code === 'auth/credential-already-in-use') {
        // This Google account already exists as a separate account. Linking is
        // refused; the guest list can't follow this account yet (Phase 3 claim
        // flow merges it server-side). Tell the user to pick another account so
        // they don't silently lose the guest list.
        err.textContent =
          'That Google account is already registered. Sign in with a different Google account to keep this guest list.';
        err.hidden = false;
        btn.disabled = false;
        return;
      }
      if (e.code === 'auth/popup-blocked') {
        err.textContent = 'Popup blocked — allow popups for this site and try again.';
        err.hidden = false;
        btn.disabled = false;
        return;
      }
      err.textContent = `Sign-in failed: ${e.message}`;
      err.hidden = false;
      btn.disabled = false;
    }
  });
}
